module.exports = {
  chevron: require('./chevron'),
  plus: require('./plus'),
  minus: require('./minus'),
  edit: require('./edit'),
  '3dots': require('./3dots'),
  'circle-back': require('./circle-back'),
  link: require('./link'),
  invisible: require('./invisible'),
};